var i18n = require("../../_i18n");

module.exports = {
  ClientCol: [
    [
      {
        field: "userName",
        title: i18n._i18n("用户名"),
        templet: function (res) {
          return res.userName ? res.userName.displayName : "";
        },
      },
      {
        field: "clientIp",
        title: i18n._i18n("客户端IP"),
      },
      {
        field: "os",
        title: i18n._i18n("操作系统"),
      },
      {
        field: "deviceCode",
        title: i18n._i18n("设备码"),
      },
      {
        field: "clientAgent",
        title: i18n._i18n("客户端"),
      },
      {
        field: "safety",
        title: i18n._i18n("是否安全设备"),
        templet: function (res) {
          var value = res.safety ? "是" : "否";
          var className = res.safety ? "layui-btn-normal" : "";
          return (
            '<a class="layui-btn ' +
            className +
            ' layui-btn-xs" lay-event="detail">' +
            value +
            "</a>"
          );
          // return (
          //   '<input type="checkbox" id="' +
          //   res.id +
          //   '" name="switch" checked=' +
          //   value +
          //   ' lay-event="tabInput" lay-skin="switch" lay-filter="safety" lay-text="是|否" />'
          // );
        },
      },
    ],
  ],
};



//////////////////
// WEBPACK FOOTER
// ./src/component/clientManager/ClientCol.js
// module id = 209
// module chunks = 0